import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';

@Pipe({
  name: 'fixDomain',
})
export class FixDomainPipe implements PipeTransform {
  transform(link: string): string {
    return link.replace(environment.domain, environment.fullDomain);
  }
}
